module.exports = "const { Generator, Envelope, Filter, Operator, Music, Util } = Musika\n\nreturn t => {\n  // Start writing your Musika here!\n\n  return [0, 0]\n}\n"


//////////////////
// WEBPACK FOOTER
// ../~/raw-loader!../examples/empty.js
// module id = 44
// module chunks = 1